import React, { useMemo } from "react";
import styles from "./AdminPreview.module.css";

const CompareStructureResponse = (props) => {
	const { isOpen, showGraph, response, source, onClose, onApply, formatValue } =
		props;

	const tableName = useMemo(() => {
		if (source?.table_name) return source.table_name;
		return "{table_name}";
	}, [source]);

	if (!isOpen) return null;
	const addedColumns = response?.addedColumns || [];
	const removedColumns = response?.removedColumns || [];
	const sitesUpdates = response?.sitesUpdates || {};
	const clientUpdates = response?.clientUpdates || {};
	const voltageUpdates = response?.voltageUpdates || {};
	const inverterUpdates = response?.inverterUpdates || [];
	const hasChanges =
		addedColumns.length > 0 ||
		removedColumns.length > 0 ||
		Object.keys(sitesUpdates).length > 0 ||
		Object.keys(clientUpdates).length > 0 ||
		Object.keys(voltageUpdates).length > 0 ||
		inverterUpdates.length > 0;

	return (
		<div className="overlay translucent">
			<div id="form-container" className={showGraph}>
				<div className={`form-contents ${styles.adminPreview}`}>
					<div className="row" style={{ marginBottom: "10px" }}>
						<div className="col-sm-11"></div>
						<div className="col-sm-1">
							<span
								onClick={onClose}
								style={{ float: "right", cursor: "pointer" }}
								className="glyphicon glyphicon-remove close-approval"
							></span>
						</div>
					</div>

					{removedColumns.length > 0 && (
						<div className="alert alert-danger" role="alert">
							{`Warning: Removing columns will permanently delete column and data in GreenYellow_solar.${tableName}`}
						</div>
					)}

					<div style={{ marginBottom: "30px" }}>
						<h4>GreenYellow_solar.clients_info</h4>
						{Object.keys(clientUpdates).length === 0 ? (
							<div style={{ marginLeft: "30px" }}>No change.</div>
						) : (
							<>
								<table
									className={styles.compareStructureTable}
									style={{ width: "100%" }}
								>
									<thead>
										<tr>
											<th>Field</th>
											<th>Old</th>
											<th>New</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(clientUpdates).map(([field, values]) => (
											<tr key={field}>
												<td>
													<strong>{field}</strong>
												</td>
												<td>{formatValue(values.old)}</td>
												<td>{formatValue(values.new)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
					</div>

					<div style={{ marginBottom: "30px" }}>
						<h4>GreenYellow_solar.sites</h4>
						{Object.keys(sitesUpdates).length === 0 ? (
							<div style={{ marginLeft: "30px" }}>No change.</div>
						) : (
							<>
								<table
									className={styles.compareStructureTable}
									style={{ width: "100%" }}
								>
									<thead>
										<tr>
											<th>Field</th>
											<th>Old</th>
											<th>New</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(sitesUpdates).map(([field, values]) => (
											<tr key={field}>
												<td>
													<strong>{field}</strong>
												</td>
												<td>{formatValue(values.old)}</td>
												<td>{formatValue(values.new)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
					</div>

					<div style={{ marginBottom: "30px" }}>
						<h4>GreenYellow_solar.normal_grid_voltage</h4>
						{Object.keys(voltageUpdates).length === 0 ? (
							<div style={{ marginLeft: "30px" }}>No change.</div>
						) : (
							<>
								<table
									className={styles.compareStructureTable}
									style={{ width: "100%" }}
								>
									<thead>
										<tr>
											<th>Field</th>
											<th>Old</th>
											<th>New</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(voltageUpdates).filter(([field, values]) => field !== "site_id").map(([field, values]) => (
											<tr key={field}>
												<td>
													<strong>{field}</strong>
												</td>
												<td>{formatValue(values.old)}</td>
												<td>{formatValue(values.new)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
					</div>

					<div style={{ marginBottom: "15px" }}>
						<h4>{`GreenYellow_solar.${tableName}`}</h4>
					</div>

					<div style={{ marginBottom: "30px" }}>
						<h4>Inverters Differences (GreenYellow_solar.inverters vs solar_sites.cons_inverters)</h4>
						{inverterUpdates.length === 0 ? (
							<div style={{ marginLeft: "30px" }}>No change.</div>
						) : (
							<table
								className={styles.compareStructureTable}
								style={{ width: "100%" }}
							>
								<thead>
									<tr>
										<th>Inverter</th>
										<th>Field</th>
										<th>Old (GreenYellow_solar)</th>
										<th>New (solar_sites)</th>
									</tr>
								</thead>
								<tbody>
									{inverterUpdates.map((row) =>
										Object.entries(row.modifiedFields || {}).map(
											([field, values], index) => (
												<tr key={`${row.rowKey}-${field}`}>
													<td>
														{index === 0
															? row.inv_no || row.id || row.rowKey
															: ""}
													</td>
													<td>
														<strong>{field}</strong>
													</td>
													<td>{formatValue(values.old)}</td>
													<td>{formatValue(values.new)}</td>
												</tr>
											),
										),
									)}
								</tbody>
							</table>
						)}
					</div>

					<div style={{ marginLeft: "20px" }}>
						<h5>Added Columns</h5>
					</div>
					{addedColumns.length === 0 ? (
						<div style={{ marginLeft: "30px" }}>No additional columns.</div>
					) : (
						<table
							className={styles.compareStructureTable}
							style={{ width: "100%" }}
						>
							<tbody>
								<tr>
									<td>{addedColumns.join(", ")}</td>
								</tr>
							</tbody>
						</table>
					)}

					<div style={{ marginLeft: "20px" }}>
						<h5>Removed Columns</h5>
					</div>
					{removedColumns.length === 0 ? (
						<div style={{ marginLeft: "30px" }}>No removed columns.</div>
					) : (
						<table
							className={styles.compareStructureTable}
							style={{ width: "100%" }}
						>
							<tbody>
								<tr>
									<td>{removedColumns.join(", ")}</td>
								</tr>
							</tbody>
						</table>
					)}

					<div
						style={{
							width: "100%",
							display: "flex",
							justifyContent: "center",
							gap: "20px",
							marginTop: "30px",
						}}
					>
						<div>
							<button
								className="btn btn-primary btn-generate btn-approval"
								title="Apply change"
								onClick={onApply}
								disabled={!hasChanges}
							>
								<span>Apply change</span>
							</button>
						</div>
						<div>
							<button
								className="btn btn-secondary btn-generate btn-approval"
								title="Cancel"
								onClick={onClose}
							>
								<span>Cancel</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CompareStructureResponse;
